import React from 'react';

import Chart from 'react-apexcharts';

import { decimalUpTo } from 'Helpers/currencyFormat';

function titleCase(string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

const PieChart = (props) => {
    const { index, latestData } = props;

    let colorPalette = ['#D8C2FF', '#21005C', '#27B6FF', '#5F6171', '#000061'];

    let optionDonut = {};

    if (index < 2) {
        optionDonut = {
            chart: {
                fontFamily: 'var(--font-sans)',
                type: 'pie',
                width: '100%',
                height: 400,
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return decimalUpTo(val.toFixed(0));
                    },
                },
            },
            plotOptions: {
                pie: {
                    customScale: 0.7,
                    donut: {
                        size: '60%',

                        labels: {
                            show: true,
                            value: {
                                show: true,
                            },
                            total: {
                                show: true,
                                label: props.name,
                                fontFamily: 'var(--font-sans)',
                                fontWeight: '800',
                                color: '#000061',
                                formatter: function (w) {
                                    const total = w.globals.seriesTotals.reduce((a, b) => {
                                        return a + b;
                                    });
                                    return decimalUpTo(total.toFixed(0));
                                },
                            },
                        },
                    },
                    offsetY: -50,
                },
                stroke: {
                    colors: undefined,
                },
            },
            colors: colorPalette,
            title: {
                text: props.name,
                style: {
                    fontSize: '18px',
                    color: '#000061',
                },
            },
            series: [],
            labels: [],
            legend: {
                show: false,
                floating: true,
                showForNullSeries: true,
                showForZeroSeries: true,
                position: 'bottom',
                height: 80,
                formatter: function (seriesName, opts) {
                    return titleCase(seriesName);
                },
            },
        };
    }
    if (latestData !== undefined) {
        latestData.forEach((e) => {
            if (e.type === 'revenue' || e.type === 'expenditure') {
                let from, totals;
                if (e.from !== undefined) from = e.from;
                else if (e.name !== undefined) from = e.name;

                if (e.totals !== undefined) {
                    const total = JSON.parse(e.totals.toString());
                    if (!optionDonut.labels.includes(from)) {
                        optionDonut.series.push(total.event.total);
                    }
                    totals = total.event.total;
                } else if (e.price !== undefined) {
                    if (!optionDonut.labels.includes(from)) {
                        optionDonut.series.push(e.price);
                    }
                    totals = e.price;
                }

                if (!optionDonut.labels.includes(from)) {
                    optionDonut.labels.push(from);
                } else {
                    for (let i in optionDonut.labels) {
                        if (optionDonut.labels[i] === from) {
                            optionDonut.series[i] += totals;
                        }
                    }
                }
            }
        });
    }
    return <Chart options={optionDonut} series={optionDonut.series} type={index < 2 ? 'donut' : 'bar'} height={300} />;
};

export default React.memo(PieChart);
